import React, { Component, PropTypes } from "react";
import DataTable from "../../DataTable";
import { inject, observer } from "mobx-react";
import { action, toJS } from "mobx";

@inject("idaqExportStore")
@observer
class IdaqExportList extends Component {

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  // constructor(){
  //   super();
  // }

  componentWillMount() {
    this.props.idaqExportStore.fetchItems()
  }

  slug = 'export/idaq-export'

  columns = [
    { key: "id", label: "ID" },
    { key: "name", label: "Name" },
    { key: "protocol", label: "Protocol" },
    { key: "idaq_id", label: "Image ID" },
    { key: "idaq_id_end", label: "Image End" },
    { key: "status", label: "Status" },
  ]

  @action handleDelete = (idOrIds) => {
    const { notify } =  this.context;
    this.props.idaqExportStore.removeItems(idOrIds)
      .then(() => notify.success({ message: "Deleted successfully" }))
      .catch((err) => notify.error({ message: "Error deleting item" }));
  }

  render() {
    return (
      <div>
        <DataTable
          data={toJS(this.props.idaqExportStore.items).map((item) => {
            const status = <i className='fa fa-circle' style={{ color: !!+item.status ? 'green' : 'red' }} data-toggle="tooltip" title={!!+item.status ? 'Enabled' : 'Disabled'} />
            return { ...item, status }
          })}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='data-delivery'
          isLoading={this.props.idaqExportStore.isLoading}
          // actions={[{ label: 'Audit', link: '/export/image-export/{id}/audit' }]}
        />
        {this.props.children}
      </div>
    );
  }
}

export default IdaqExportList;


// WEBPACK FOOTER //
// ./src/components/DataDelivery/IdaqExport/IdaqExportList.js